<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M20.166 4.12604C20.5107 4.35581 20.6038 4.82146 20.374 5.1661L11.374 18.6661C11.2494 18.8531 11.0475 18.9743 10.8239 18.9964C10.6003 19.0186 10.3786 18.9393 10.2197 18.7804L4.21967 12.7804C3.92678 12.4875 3.92678 12.0126 4.21967 11.7197C4.51256 11.4269 4.98744 11.4269 5.28033 11.7197L10.6334 17.0729L19.126 4.33405C19.3557 3.98941 19.8214 3.89628 20.166 4.12604Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgCheck',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
